import React, { useEffect, useState } from "react";
import { Form, Input, Typography } from "antd";
import Modal from "components/Modal/Modal";
import { FormInput, FormInputArea } from "components/FormItems/FlatFormItems";
import { Button } from "components/Buttons/Buttons";

const { TextArea } = Input;
const { Text } = Typography;

export default function ReasonModal({
  title, text,
  visible,
  okButtonText = "Save",
  onCancel, onSave, children,
  isFetching = false,
  labelForTextArea="Note"
}) {
  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onSave(values); // Pass the note value to the onSave handler
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  useEffect(() => {
    if (visible === false) {
      form.resetFields();
    }
  }, [visible]);

  return (
    <Modal
      title={title}
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button key="back" rounded variant="outlined" onClick={onCancel}>
            Cancel
          </Button>,
          <Button rounded key="submit" onClick={handleOk}
            disabled={isFetching}
          >
            {okButtonText}
          </Button>
        </div>
      }
    >
      <Text style={{marginBottom: 8}}>{text}</Text>
      <Form
        form={form}
        layout="vertical"
        name="note_form"
        requiredMark={false}
        disabled={isFetching}
        preserve={false}
      >
        {children}
        
        <FormInputArea
          variant="underlined"
          rows={4}
          name="note"
          label={labelForTextArea}
          placeholder="Provide the reason"
          formItemStyles={{ marginBottom: 0 }}
          required={true}
        />
      </Form>
    </Modal>
  );
}
